module.exports = __webpack_public_path__ + "assets/img/okButton.391bcd65.svg";